import Vue from "vue";
import Component from "vue-class-component";
import { ISources } from "@/entity/sources/sources.types";
import { SourcesStore } from "@/store/modules/Sources";
import {SourceCategoriesForm} from '@/UI/pages/Settings/Source/lib/sourceForm';

@Component
export class SourcesMix extends Vue {
    sourceModal = false;
    sourceSaving = false;
    sourceForm = new SourceCategoriesForm();

    openSourceForm(): void {
        this.sourceForm = new SourceCategoriesForm();
        this.sourceForm.color = '#7360ed';
        this.sourceModal = true;
    }

    async addSource(form: any): Promise<void> {
        if (this.sourceSaving || !this.sourceForm.name?.trim()) return;
        this.sourceSaving = true;
        try {
            const data = {...this.sourceForm, name: this.sourceForm.name.trim(), link: null, salon_id: form.salon_id};
            const response: any = await SourcesStore.create(data);
            if (!response.status || !response.id) throw new Error(response.response);
            await SourcesStore.fetchAll(form.salon_id);
            form.source = Array.from(new Set([...(form.source || []), Number(response.id)]));
            this.sourceModal = false;
        } catch (error) {
            const body = error.response?.data;
            this.$message.error(body?.errors ? Object.values(body.errors).flat().join(' ') : body?.message || error.message);
        } finally {
            this.sourceSaving = false;
        }
    }

    get sources(): ISources[] {
        return SourcesStore.sources;
    }
}
